import React from "react";
import axios from "axios";
import {isMobileOnly} from "react-device-detect";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import magnifier from '../../assets/magnifier.svg';
import Moment from "react-moment";
import {EmailShareButton, FacebookIcon, FacebookShareButton, TwitterIcon, TwitterShareButton} from "react-share";
import {CopyToClipboard} from "react-copy-to-clipboard";
import SocialList from "../../assets/social_list.svg";
import {DropdownButton, DropdownItem} from "react-bootstrap";
import ctc from '../../assets/ctclipboard.png';
import openEmail from '../../assets/openEmail.png';
import xButton from '../../assets/X.svg';
import DoubleTemplateComponent from "../../containers/template_page/double_template_component/double_template_component";
import ReactPlayer from "react-player";
import './c80_tutte_le_notizie_filtered.scss';
import {insertHtml} from "../../utils/dom";

const SVG_ID = "#svg_id";

/* Content of the month dropdown */
const optionsMonths = [
    {value: '', label: 'All Months'},
    {value: '-01', label: 'Gennaio'},
    {value: '-02', label: 'Febbraio'},
    {value: '-03', label: 'Marzo'},
    {value: '-04', label: 'Aprile'},
    {value: '-05', label: 'Maggio'},
    {value: '-06', label: 'Giugno'},
    {value: '-07', label: 'Luglio'},
    {value: '-08', label: 'Agosto'},
    {value: '-09', label: 'Settembre'},
    {value: '-10', label: 'Ottobre'},
    {value: '-11', label: 'Novembre'},
    {value: '-12', label: 'Dicembre'}
];

class TutteLeNotizieFiltered extends DoubleTemplateComponent {

    _c = window.location.href.includes('category') ? window.location.href.substring(window.location.href.lastIndexOf('news') + 5, window.location.href.lastIndexOf("&") + 1) : '';
    _y = window.location.href.includes('year') ? window.location.href.substring(window.location.href.lastIndexOf('category') + 46, window.location.href.lastIndexOf("_")) : '';
    _m = window.location.href.includes('month') ? window.location.href.substring(window.location.href.lastIndexOf('year') + 10, window.location.href.lastIndexOf("|") + 1) : '';
    _s = window.location.href.includes('search') ? window.location.href.substring(window.location.href.lastIndexOf('search') + 7, window.location.href.lastIndexOf("")) : '';

    uuid = this._c;
    date = this._y;
    month = this._m;
    searchfor = this._s;

    constructor(props) {
        super(props);
        this.state = {
            optionsCategory: [],
            arrayCallCat: [],
            disabled: true,
            searchTerm: '',
            isHidden: true,
            filters: ['title', 'date'],
            isVideoHidden: false,
            playing: false,
            valueCat: '',
            valueYear: '',
            valueMonth: '',
        };
        this.notizieRef = React.createRef();
        this.requireInternationalization = true;
        this.loadTaxonomy();
    };

    componentDidMount() {
        super.componentDidMount();
        this.loadTaxonomy();
        //create date from 2015 to current year
        var startYear = '2015';
        var currYear = new Date().getFullYear();
        var arrYear = [];
        for (startYear; startYear<currYear+1; startYear++){
            arrYear.push(startYear.toString());
        }
        arrYear.unshift('Years');
        this.setState({
            optionsYears: arrYear
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        super.componentDidUpdate(prevProps, prevState, snapshot);

        if (this.props.language !== prevProps.language) {
            this.loadTaxonomy();
        }
    }

    loadTaxonomy() {
        let epCategory = '';
        axios.get(this.props.url).then(response => {
            this.setState.allData = response
            epCategory = `${response.data.__other_data[0]}`;
        }).then(() => axios.get(epCategory)).then(res => {
            this.setState({
                optionsCategory: res.data.terms.map(el => el.label),
                arrayCallCat: res.data.terms
            });
            this.state.optionsCategory.length > 1 ? this.state.optionsCategory.unshift('All') : this.state.optionsCategory=[];
        }).then(
            () => this.setFilters()
        ).then(
            () => this.callFilter()
        );
    }

    handleurl = (sender, selected) => {
        switch (sender) {
            case 'category':
                this._c = selected;
                break;
            case 'year':
                this._y = selected;
                this._m = this._y === '' ? '' : this._m;
                break;
            case 'month':
                this._m = selected;
                break;
            case 'search':
                this._s = selected;
                break;
            default:
        }
        const qmSign = (this._c === '' && this._y === '' && this._s === '') ? '' : '?';
        window.history.replaceState("", "", '/nuovo-blocco-news' + qmSign + this._c + this._y + this._m + this._s);
    }

    setFilters = () => {
        const categoryId = this._c.substring(this._c.lastIndexOf('category') + 9, this._c.lastIndexOf('&'));
        const cat = categoryId => this.state.arrayCallCat.find(obj => obj.id === categoryId);
        this.uuid = categoryId;

        const year = this._y.substring(this._y.lastIndexOf('year') + 5, this._y.lastIndexOf('_'));
        this.date = year;

        const month = this._m.substring(this._m.lastIndexOf('month') + 6, this._m.lastIndexOf('|'));
        const monthExists = optionsMonths.some(obj => obj.value === month);
        this.month = month;

        this.setState({
            valueCat: (categoryId) ? cat(categoryId).label : this.state.valueCat,
            valueYear: (year && this.state.optionsYears.includes(year)) ? year : this.state.valueYear,
            disabled: (month && monthExists) ? false : this.state.disabled,
            valueMonth: (month && monthExists) ? month : this.state.valueMonth,
            query: this._s
        })
    }

    callFilter = async () => {
        const catsAll = this.state.data.__data.substring(this.state.data.__data.lastIndexOf('cats') + 5, this.state.data.__data.lastIndexOf(""));

        try {
            let params = {
                "views": true,
                "limit": 9,
                "search": this.searchfor ? this.searchfor : '',
                "cats": this.uuid ? this.uuid : catsAll,
                "date": (this.date || this.month) ? this.date + this.month : ''
            };
            const baseUrl = this.state.data.__data.substring(this.state.data.__data.lastIndexOf('http'), this.state.data.__data.lastIndexOf("filterednews") + 13) + this.props.language;
            const response = await axios.get(baseUrl, {params: params});
            if (response.status < 300) {
                this.setState({
                    data: {...this.state.data, ...response.data},
                    searchTerm: response.data.title
                });
            }
            return response.data;
        } catch (e) {
            return null
        }
    };

    changeCategory = selected => {
        selected = selected.value;
        this.getValCat(selected);
        if (selected === 'All') {
            selected = '';
            this.uuid = '';
            this.handleurl('category', '');
            this.callFilter();
        }
        // for each category in arrayCallCat find uuid based on selected value of category name
        this.state.arrayCallCat.forEach((filterString) => {
            for (var key in filterString){
                if(filterString[key] === selected){
                    this.uuid = filterString.id;
                    this.handleurl('category',`category=${this.uuid}&`);
                    return this.callFilter();
                }
            }
        })
    };

    changeYear = selected => {
        this.disableDrop(false);
        selected = selected.value.toString();
        this.getValYear(selected);
        if (selected === 'Years') {
            selected = '';
            this.disableDrop(true);
            this.month = '';
            this.getValMonth('');
            this.handleurl('year', '');
        } else {
            this.handleurl('year',`year=${selected}_`);
        }
        this.date = selected;
        this.callFilter();
    };

    changeMonth = selected => {
        selected= selected.value;
        this.getValMonth(selected);
        if (selected === '') {
            selected = ''
            this.handleurl('month', '');
        } else {
            this.handleurl('month',`month=${selected}|`);
        }
        this.month = selected;
        this.callFilter();
    };

    changeSearch = event => {
        event.preventDefault();
        if (document.forms.newsSearch.search.value) {
            this.searchfor = document.forms.newsSearch.search.value;
            this.handleurl('search', `search=${this.searchfor}`);
            this.callFilter();
        } else {
            this.searchfor = ''
            this.handleurl('search', '');
            this.callFilter();
        }
    };

    getValCat = val =>{
        this.setState ({valueCat: val});
    };
    getValYear = val =>{
        this.setState ({valueYear: val});
    };
    getValMonth = val =>{
        this.setState ({valueMonth: val});
    };

    disableDrop = (value) => {
        this.setState({disabled: value})
    };

    playVideo = () => {
        this.setState({
            isHidden: true,
            playing: true
        })
    };

    onCopy = () => {
        this.setState({copied: true});
    };

    showMore = ep => {
        axios.get(ep, {
        }).then(res => {
            let cards = this.state.data.cards.concat(res.data.cards);
            this.setState({
                callMore: true,
                data: {...this.state.data, ...{cards: cards, next_page: res.data.next_page}}
            });
        });
    };

    /**
     * Render a single card for a news
     *
     * @param card
     * @returns {*}
     */
    renderCard(card, index) {
        return (
            <React.Fragment key={index}>
                { card.video && card.length > 0 &&
                <div className="col-xl-8 col-md-12" key={index}>
                    {(!isMobileOnly) ?
                        <div className="tutte-le-notizie-filtered-first-card mx-auto">
                            {card.video &&
                            <div className="tutte-le-notizie-filtered-card-video-container">
                                <ReactPlayer className="card-video w-100 h-100"
                                             url={card.video}
                                             ref={this.notizieRef}
                                             controls={!this.state.isHidden}
                                             playing={this.state.playing}/>
                                {!this.state.isVideoHidden &&
                                <button className="card-video-button"
                                        onClick={() => this.playVideo()}>
                                    <div className="card-video-triangle"/>
                                </button>
                                }
                            </div>
                            }
                            <div className={"tutte-le-notizie-filtered-card-content-container"}>
                                {/* {card.categories && card.categories.length > 0 ? <div className="tutte-le-notizie-filtered-first-card-category">{card.categories[0].label}</div> : null } */}
                                <div className="tutte-le-notizie-filtered-first-card-title">{card.title}</div>
                                {card.content &&
                                <div className="tutte-le-notizie-filtered-first-card-content" {...insertHtml(card.content)} />}
                                <div className="tutte-le-notizie-filtered-social">
                                    <span className="card-social-net-section-title">SHARE:</span>
                                    <span>
                                        <ul className="card-social-net-links-list">
                                            <li>
                                                <FacebookShareButton
                                                    url={'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href}
                                                    quote={'Le ultime news'}
                                                    className="Demo__some-network__share-button">
                                                    <FacebookIcon size={50} logoFillColor={'#003a70'}
                                                                  iconBgStyle={{fill: 'transparent'}}/>
                                                </FacebookShareButton>
                                            </li>
                                            <li>
                                                <TwitterShareButton url={window.location.href}>
                                                    <TwitterIcon size={50} logoFillColor={'#003a70'}
                                                                 iconBgStyle={{fill: 'transparent'}}/>
                                                </TwitterShareButton>
                                            </li>
                                            <li>
                                                <CopyToClipboard onCopy={this.onCopy}
                                                                 text={window.location.href}>
                                                        <img src={ctc} alt="Luiss.it"
                                                             className="tutte-le-notizie-filtered-ctc"/>
                                                </CopyToClipboard>
                                            </li>
                                            <li>
                                                <EmailShareButton
                                                    url={window.location.href}
                                                    subject={'Le ultime news'}
                                                    className="Demo__some-network__share-button">
                                                    <img src={openEmail} alt="Luiss.it"
                                                         className="tutte-le-notizie-filtered-email"/>
                                                </EmailShareButton>
                                            </li>
                                        </ul>
                                    </span>
                                </div>
                                {card.date &&
                                <div className="tutte-le-notizie-filtered-first-card-date">
                                    <Moment date={card.date} format="D MMMM YYYY"/>
                                </div>
                                }
                                <div className="tutte-le-notizie-filtered-first-card-cta"><a
                                    href={card.link_url}>{card.link_title}</a>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="tutte-le-notizie-filtered-first-card-mob mx-auto">
                            <div className="tutte-le-notizie-filtered-card-video-container">
                                <video className="tutte-le-notizie-filtered-card-video"
                                       ref={this.notizieRef} controls={this.state.isVideoHidden}>
                                    <source src={card.video} type="video/mp4"/>
                                </video>
                                {!this.state.isVideoHidden &&
                                <button className="card-video-button" onClick={() => this.playVideo()}>
                                    <div className="card-video-triangle"/>
                                </button>
                                }
                            </div>
                            <div className="tutte-le-notizie-filtered-card-content-container">
                                {/* {card.categories && card.categories.length > 0 ? <div className="tutte-le-notizie-filtered-first-card-category">{card.categories[0].label}</div> : null } */}
                                <div className="tutte-le-notizie-filtered-first-card-title">{card.title}</div>
                                {card.content &&
                                <div className="tutte-le-notizie-filtered-first-card-content" {...insertHtml(card.content)} />
                                }

                                <div className="tutte-le-notizie-filtered-social">
                                    <div className="social-share-shadow" />
                                    <div className="social-share" />
                                    <svg className="social-list-button">
                                        <use xlinkHref={`${SocialList}${SVG_ID}`} />
                                    </svg>
                                    <div className="dropup">
                                        <DropdownButton drop={'up'} variant="secondary"
                                                        id={'dropdown-button-drop-up'} key={'up'}
                                                        title=" ">
                                            <li>
                                                <FacebookShareButton
                                                    url={'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href}
                                                    quote={'Le ultime news'}
                                                    className="Demo__some-network__share-button">
                                                    <FacebookIcon size={50} logoFillColor={'#003a70'}
                                                                  iconBgStyle={{fill: 'transparent'}}/>
                                                </FacebookShareButton>
                                            </li>
                                            <li>
                                                <TwitterShareButton
                                                    url={window.location.href}>
                                                    <TwitterIcon size={50} logoFillColor={'#003a70'}
                                                                 iconBgStyle={{fill: 'transparent'}}/>
                                                </TwitterShareButton>
                                            </li>
                                            <li>
                                                <CopyToClipboard onCopy={this.onCopy}
                                                                 text={window.location.href}>
                                                    <img src={ctc} alt="Luiss.it"
                                                         className="tutte-le-notizie-filtered-ctc"/>
                                                </CopyToClipboard>
                                            </li>
                                            <li>
                                                <EmailShareButton
                                                    url={window.location.href}
                                                    subject={'Le ultime news'}
                                                    className="Demo__some-network__share-button">
                                                    <img src={openEmail} alt="Luiss.it"
                                                         className="tutte-le-notizie-filtered-email"/>
                                                </EmailShareButton>
                                            </li>
                                            <li>
                                                <DropdownItem>
                                                    <div className="social-share-shadow-drop" />
                                                    <div className="social-share-drop" />
                                                    <svg className="social-list-button-drop">
                                                        <use xlinkHref={`${xButton}${SVG_ID}`} />
                                                    </svg>
                                                </DropdownItem>
                                            </li>
                                        </DropdownButton>
                                    </div>
                                </div>
                                {card.date &&
                                <div className="tutte-le-notizie-filtered-first-card-date">
                                    <Moment date={card.date} format="D MMMM YYYY"/>
                                </div>
                                }
                                <div className="tutte-le-notizie-filtered-first-card-cta">
                                    <a href={card.link_url}>{card.link_title}</a>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                }
                <div className="col-xl-4 col-md-6" key={"card-" + card.link_url}>
                    <div className="tutte-le-notizie-filtered-card mx-auto">
                        <div className='separator'/>
                        {/* {card.categories && card.categories.length > 0 ? <div className="tutte-le-notizie-filtered-card-category">{card.categories[0].label}</div> : null } */}
                        <div className="tutte-le-notizie-filtered-card-title">{card.title}</div>
                        {card.date &&
                            <div className="tutte-le-notizie-filtered-card-date">
                                <Moment date={card.date} format="D MMMM YYYY" />
                            </div>
                        }
                        <div className="tutte-le-notizie-filtered-card-cta">
                            <a href={card.link_url}>{card.link_title}</a>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    internationalComponentRender(allData, t) {
        let filteredCards = allData.cards;

        return (
            <div id={!isMobileOnly ? 'tutte-le-notizie-filtered-grid' : 'tutte-le-notizie-filtered-grid-mob'} className="c52-news">
                <div className="container container-search-fields">
                    <div className="row">
                        { this.state.optionsCategory.length === 0 ? null :
                        <Dropdown
                            options={this.state.optionsCategory}
                            onChange={this.changeCategory}
                            value={this.state.valueCat}
                            placeholder="All"
                            className={!isMobileOnly ? 'dropdown-categories col-4' : 'dropdown-categories'}
                        />
                        }
                        <Dropdown
                            options={optionsMonths}
                            onChange={this.changeMonth}
                            value={this.state.valueMonth}
                            disabled = {this.state.disabled}
                            placeholder="Month"
                            className={!isMobileOnly ? 'dropdown-months col-2' : 'dropdown-months'}
                        />
                        <Dropdown
                            options={this.state.optionsYears}
                            onChange={this.changeYear}
                            value={this.state.valueYear}
                            placeholder="Year"
                            className={!isMobileOnly ? 'dropdown-years col-2' : 'dropdown-years'}
                        />
                        <form onSubmit={this.changeSearch} name="newsSearch" className={!isMobileOnly ? 'search-bar-tutte-le-notizie-filtered col-4' :
                            (!this.state.isHidden ? 'search-bar-tutte-le-notizie-filtered' : "search-bar-tutte-le-notizie-filtered text-right")}>
                            <button className="tutte-le-notizie-filtered-search-button" onClick={this.showSearchField}>
                                <svg className="magnifier-tutte-le-notizie-filtered">
                                    <use xlinkHref={`${magnifier}${SVG_ID}`}/>
                                </svg>
                            </button>
                            <input name="search" className="search-input" defaultValue={this.searchfor}/>
                        </form>
                    </div>
                </div>
                <div className="container">
                    <div className="row tutte-le-notizie-filtered-card-row">
                        {(filteredCards && filteredCards.length > 0) ?
                            filteredCards.map((card, index) =>
                                this.renderCard(card, index)) :
                            <p className={'not-found'}>{t("C52 no content")}</p>
                        }
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center">
                                {(allData.next_page !== '' && filteredCards && filteredCards.length > 0) &&
                                    <button className="tutte-le-notizie-filtered-carica-altro-btn" onClick={() => this.showMore(allData.next_page)}>
                                        {allData.loadmore_label}
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TutteLeNotizieFiltered;
